<template>
    <div>

        <div class="text-left">
            <h3 class="mb-3">{{$t('cal_curr_Convertor')}}</h3>
            <p>{{$t('cal_curr_conv_txt')}}</p>

        </div>
        <div class="verticallyTab mt-5">
            
            <div class="bottomTab">
                <div class="stepForm-contact mt-5">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" v-model="selectedSymbolFrom" v-validate="'required'" name="selectedSymbolFrom" :class="{ 'is-invalid': submitted && errors.has('selectedSymbolFrom'), 'active' : selectedSymbolFrom != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                   <!--  <option value=""></option> -->
                                   <option v-for="spreads in currencyList">{{spreads}}</option>
                                </select>
                                <label class="float-label">{{$t('cal_curr_conv_From')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('selectedSymbolFrom')">{{$t('cal_curr_conv_Field_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" v-model="selectedSymbolTo" v-validate="'required'" name="selectedSymbolTo" :class="{ 'is-invalid': submitted && errors.has('selectedSymbolTo'), 'active' : selectedSymbolTo != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                   <!-- <option value=""></option> -->
                                   <option v-for="spreads in currencyList" :value="spreads">{{spreads}}</option>
                                </select>
                                <label class="float-label">{{$t('cal_curr_conv_To')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('selectedSymbolTo')">{{$t('cal_curr_conv_Field_req')}}</p>
                            </div>
                        </div> 
                        <div class="col-12 col-md-12">
                            <div class="form-group field-wrapper">
                                <input type="text" placeholder=" " class="float-field form-control"  v-model="amount" v-validate="{ required: true,decimal:10}" name="amount" :class="{ 'is-invalid': submitted && errors.has('amount') }">
                                <label class="float-label">{{$t('cal_curr_conv_Amount')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('amount')">{{$t('cal_curr_conv_Field_req')}}</p>
                            </div>
                        </div>
                         
                        <div class="col-12 col-md-12">
                            <div class="form-group field-wrapper">
                                <a href="#" class="common_btn" v-on:click.prevent="calculateComm()">{{$t('cal_curr_conv_Now')}}</a>
                                <p class="mt-3"><strong>{{$t('cal_curr_conv_Converted')}}</strong>: {{selectedSymbolTo}} {{amountConverted.toFixed(2)}}</p>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>  
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'CurrencyConverter',
        mixins: [fxViewMixins],
        data() {
            return {
                "isins":'',
                currencyList: ["EUR","USD","GBP","CAD","CHF","AUD","NZD","NOK","JPY","ZAR","TRY","SGD","SEK","PLN","CZK","DKK","HKD","CNH","MXN","HUF","RUB","RON","ILS"],
                selectedSymbolTo:'',
                selectedSymbolFrom:'',
                amount: 0,
                amountConverted:0,
				submitted : false
            }
        },
        methods:{
            getfirstthreeChar(spreads){
                return spreads.toString().substring(0,3)
            },
            getLastthreeChar(spreads){
                return spreads.toString().substring(3,6)
            },
            calculateComm(){
				const _that = this
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
						//selected symbol
                
						if(_that.selectedSymbolFrom !== _that.selectedSymbolTo){
							let currencyPrice = _that.currencyConverstion(_that.selectedSymbolFrom+_that.selectedSymbolTo)
							
                            //console.log("currencyPrice============>", currencyPrice);
                            //console.log("currencyPrice============>", _that.amount);
                            
                            _that.amountConverted = currencyPrice * _that.amount
                        
                        }
						else{
                            //console.log("both are same")
							_that.amountConverted = _that.amount
						}

						// Pip size X Contract size X (Second currency conversion to Base currency ) 

						// No. of Lots X Swap Points X Contract Size X Minimum Price Fluctuations X Days * Conversion price to account base currency
					}
				})
            },
            currencyConverstion(selectedSymbol){
                //all_currencies_price will get all currecies prices

                let firstCurrency = selectedSymbol.substring(0, 3);
                let secondCurrency = selectedSymbol.substring(3, 6);

                //console.log(this.all_currencies_price)
                
                if(secondCurrency == firstCurrency){
                    return 1
                }

                else if(this.all_currencies_price[secondCurrency+firstCurrency]){
                    return 1/this.all_currencies_price[secondCurrency+firstCurrency].A
                } 

                else if(this.all_currencies_price[firstCurrency+secondCurrency]){
                    return this.all_currencies_price[firstCurrency+secondCurrency].A
                } 
                else{

                    let secontoUSD = 0
                    let accBasetoUSD = 0
                    if(this.all_currencies_price[secondCurrency+"USD"]){
                        secontoUSD = this.all_currencies_price[secondCurrency+"USD"].A
                    } 
                    else if(this.all_currencies_price["USD"+secondCurrency]){
                        secontoUSD = 1/this.all_currencies_price["USD"+secondCurrency].A
                    } 

                    if(this.all_currencies_price[firstCurrency+"USD"]){
                        accBasetoUSD = this.all_currencies_price[firstCurrency+"USD"].A
                    } 
                    else if(this.all_currencies_price["USD"+firstCurrency]){
                        accBasetoUSD = 1/this.all_currencies_price["USD"+firstCurrency].A
                    } 

                    return accBasetoUSD * secontoUSD
                }
                return 1
            }
        },
        computed: {


        },
        mounted() {

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/calculators/currency_convertor.vue